/* FasterFlate custom theme layer */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && window.theme.money_format) || '${{amount}}';
    function delim(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = delim(cents, 2); break;
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('.ff-header');
    if (!header) return;

    var setH = function () {
      var bar = $('.ff-header__bar', header);
      if (bar) document.documentElement.style.setProperty('--ff-header-h', header.classList.contains('ff-header--sticky') ? bar.offsetHeight + 'px' : '0px');
    };
    setH();
    window.addEventListener('resize', setH);

    var drawer = $('#ff-drawer');
    var lastFocus = null;
    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ff-lock');
      $$('[data-ff-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var close = $('[data-ff-drawer-close].ff-icon-btn', drawer);
      if (close) close.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ff-lock');
      $$('[data-ff-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-ff-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    $$('[data-ff-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });

    var search = $('#ff-search');
    $$('[data-ff-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!search) return;
        e.preventDefault();
        var open = search.hasAttribute('hidden');
        if (open) { search.removeAttribute('hidden'); var i = $('input[type="search"]', search); if (i) i.focus(); }
        else search.setAttribute('hidden', '');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- reveal (only below-the-fold, so nothing flickers) ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.body.getAttribute('data-editor-mode') === 'true') return;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-ff-reveal]').forEach(function (el) {
      if (el.getBoundingClientRect().top > vh) { el.classList.add('ff-reveal'); io.observe(el); }
    });
  }

  /* ---------- product ---------- */
  function initProduct(root) {
    var dataEl = $('[data-ff-variants]', root);
    var form = $('form[data-ff-product-form]', root);
    if (!dataEl || !form) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = $('input[name="id"]', form);
    var addBtn = $('[data-ff-add]', root);
    var addLabel = addBtn ? $('[data-ff-add-label]', addBtn) : null;
    var priceEl = $('[data-ff-price]', root);
    var stockEl = $('[data-ff-stock]', root);
    var skuEl = $('[data-ff-sku]', root);
    var labels = {
      add: addBtn ? addBtn.getAttribute('data-label-add') : 'Add to cart',
      soldout: addBtn ? addBtn.getAttribute('data-label-soldout') : 'Sold out',
      unavailable: addBtn ? addBtn.getAttribute('data-label-unavailable') : 'Unavailable'
    };
    var lowLimit = parseInt(root.getAttribute('data-low-stock') || '0', 10);

    function currentOptions() {
      return $$('[data-ff-option]', root).map(function (group) {
        if (group.tagName === 'SELECT') return group.value;
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      $$('[data-ff-option]', root).forEach(function (group, idx) {
        if (group.tagName === 'SELECT') return;
        $$('.ff-pill', group).forEach(function (pill) {
          var input = $('input', pill);
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
        var out = $('output', group.closest('.ff-opt'));
        var checked = $('input:checked', group);
        if (out && checked) out.textContent = checked.value;
      });
    }

    function renderPrice(v) {
      if (!priceEl || !v) return;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<span class="ff-price__now">' + formatMoney(v.price) + '</span>';
      if (sale) {
        html += '<s>' + formatMoney(v.compare_at_price) + '</s>';
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<span class="ff-badge ff-badge--sale">Save ' + pct + '%</span>';
      }
      var tax = $('.ff-info__tax', priceEl);
      priceEl.innerHTML = html;
      if (tax) priceEl.appendChild(tax);
      priceEl.classList.toggle('ff-sale', !!sale);
    }

    function renderStock(v) {
      if (!stockEl) return;
      stockEl.className = 'ff-stock';
      if (!v) { stockEl.textContent = labels.unavailable; stockEl.classList.add('ff-stock--out'); return; }
      if (!v.available) { stockEl.textContent = labels.soldout; stockEl.classList.add('ff-stock--out'); return; }
      var qty = stockEl.getAttribute('data-qty-' + v.id);
      if (qty !== null && lowLimit && parseInt(qty, 10) > 0 && parseInt(qty, 10) <= lowLimit) {
        stockEl.textContent = 'Only ' + qty + ' left';
        stockEl.classList.add('ff-stock--low');
      } else {
        stockEl.textContent = stockEl.getAttribute('data-in-stock') || 'In stock';
      }
    }

    function update(pushUrl) {
      var opts = currentOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      if (addBtn) {
        var can = !!(v && v.available);
        addBtn.disabled = !can;
        if (addLabel) addLabel.textContent = !v ? labels.unavailable : (v.available ? labels.add : labels.soldout);
      }
      renderStock(v);
      if (!v) return;
      idInput.value = v.id;
      renderPrice(v);
      if (skuEl) skuEl.textContent = v.sku || '';
      if (v.featured_media && v.featured_media.id) gotoMedia(root, String(v.featured_media.id));
      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('ff:variant', { detail: v, bubbles: true }));
    }

    $$('[data-ff-option]', root).forEach(function (group) {
      group.addEventListener('change', function () { update(true); });
    });

    /* qty */
    $$('[data-ff-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          var n = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = n;
        });
      });
    });

    update(false);
  }

  /* ---------- gallery ---------- */
  function gotoMedia(root, mediaId) {
    var gallery = $('[data-ff-gallery]', root);
    if (!gallery) return;
    var slides = $$('.ff-gallery__slide', gallery);
    var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === mediaId; });
    if (idx > -1) setSlide(gallery, idx);
  }

  function setSlide(gallery, idx) {
    var slides = $$('.ff-gallery__slide', gallery);
    var thumbs = $$('.ff-thumb', gallery);
    if (!slides.length) return;
    idx = (idx + slides.length) % slides.length;
    slides.forEach(function (s, i) {
      var on = i === idx;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (!on) {
        var vid = $('video', s); if (vid) vid.pause();
      }
    });
    thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    var counter = $('[data-ff-counter]', gallery);
    if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    gallery.setAttribute('data-index', idx);
  }

  function initGallery(root) {
    var gallery = $('[data-ff-gallery]', root);
    if (!gallery) return;
    var cur = function () { return parseInt(gallery.getAttribute('data-index') || '0', 10); };
    $$('.ff-thumb', gallery).forEach(function (t, i) { t.addEventListener('click', function () { setSlide(gallery, i); }); });
    var prev = $('[data-ff-prev]', gallery), next = $('[data-ff-next]', gallery);
    if (prev) prev.addEventListener('click', function () { setSlide(gallery, cur() - 1); });
    if (next) next.addEventListener('click', function () { setSlide(gallery, cur() + 1); });
    var stage = $('.ff-gallery__stage', gallery), x0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) setSlide(gallery, cur() + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }
    var start = $$('.ff-gallery__slide', gallery).findIndex(function (s) { return s.classList.contains('is-active'); });
    setSlide(gallery, start > -1 ? start : 0);
  }

  /* ---------- recommendations ---------- */
  function initRecs() {
    $$('[data-ff-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var fresh = tmp.querySelector('[data-ff-recs]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          el.removeAttribute('hidden');
        }
      }).catch(function () {});
    });
  }

  /* ---------- collection sort ---------- */
  function initSort() {
    $$('[data-ff-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function init() {
    initHeader();
    $$('[data-ff-product]').forEach(function (root) { initGallery(root); initProduct(root); });
    initRecs();
    initSort();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    $$('[data-ff-product]', root).forEach(function (r) { initGallery(r); initProduct(r); });
    if ($('.ff-header', root)) initHeader();
  });
})();
